import axios from "axios";
//GET ALL CARCATAGORY BY COUNTRY
export const GET_ALL_INVOICES = "GET_ALL_INVOICES";
export const GET_ALL_INVOICES_LOADING =
"GET_ALL_INVOICES_LOADING";
export const GET_ALL_INVOICES_LOADING_FAILED =
"GET_ALL_INVOICES_LOADING_FAILED";

// HELPER ACTIONS CREATORS
//************************************** /

export const getAllInvoicesLoading = ms => ({
    type: GET_ALL_INVOICES_LOADING,
    payload: ms
    });
    
    export const getAllInvoicesLoadingFailed = ms => ({
    type: GET_ALL_INVOICES_LOADING_FAILED,
    payload: ms
    });

// RIDER PHINE NUBER
export function getAllInvoices(obj) {
/*   console.log(obj,"jjjjjjjjjjjjj") */
  if(obj.status===undefined && obj.isSent===undefined && obj.userId===undefined){
    var request = axios.get(
      `${process.env.REACT_APP_FILE}/accountRoutes/api/v1/caseInvoices/getInvoicesWithPagination?limit=${obj.limit}&pageNo=${obj.pageNo}`,
      {
        headers: { 'Authorization': 'bearer ' +localStorage.accountantToken}
      });
  }else if(obj.status===undefined && obj.isSent!=undefined && obj.userId===undefined){
    var request = axios.get(
      `${process.env.REACT_APP_FILE}/accountRoutes/api/v1/caseInvoices/getInvoicesWithPagination?isSent=${obj.isSent}&limit=${obj.limit}&pageNo=${obj.pageNo}`,
      {
        headers: { 'Authorization': 'bearer ' +localStorage.accountantToken}
      });
  }else if(obj.isSent===undefined && obj.status!=undefined && obj.userId===undefined ){
    var request = axios.get(
      `${process.env.REACT_APP_FILE}/accountRoutes/api/v1/caseInvoices/getInvoicesWithPagination?status=${obj.status}&limit=${obj.limit}&pageNo=${obj.pageNo}`,
      {
        headers: { 'Authorization': 'bearer ' +localStorage.accountantToken}
      });
  }else if(obj.isSent===undefined && obj.status!=undefined && obj.userId!=undefined ){
    var request = axios.get(
      `${process.env.REACT_APP_FILE}/accountRoutes/api/v1/caseInvoices/getInvoicesWithPagination?userId=${obj.userId}&status=${obj.status}&limit=${obj.limit}&pageNo=${obj.pageNo}`,
      {
        headers: { 'Authorization': 'bearer ' +localStorage.accountantToken}
      });
  }else if(obj.isSent!=undefined && obj.status===undefined && obj.userId!=undefined ){
    var request = axios.get(
      `${process.env.REACT_APP_FILE}/accountRoutes/api/v1/caseInvoices/getInvoicesWithPagination?isSent=${obj.isSent}&userId=${obj.userId}&limit=${obj.limit}&pageNo=${obj.pageNo}`,
      {
        headers: { 'Authorization': 'bearer ' +localStorage.accountantToken}
      });
  }else if(obj.isSent===undefined && obj.status===undefined && obj.userId!=undefined ){
    var request = axios.get(
      `${process.env.REACT_APP_FILE}/accountRoutes/api/v1/caseInvoices/getInvoicesWithPagination?userId=${obj.userId}&limit=${obj.limit}&pageNo=${obj.pageNo}`,
      {
        headers: { 'Authorization': 'bearer ' +localStorage.accountantToken}
      });
  }else if(obj.isSent!=undefined && obj.status!=undefined && obj.userId===undefined ){
    var request = axios.get(
      `${process.env.REACT_APP_FILE}/accountRoutes/api/v1/caseInvoices/getInvoicesWithPagination?isSent=${obj.isSent}&status=${obj.status}&limit=${obj.limit}&pageNo=${obj.pageNo}`,
      {
        headers: { 'Authorization': 'bearer ' +localStorage.accountantToken}
      });
  }else if(obj.isSent!=undefined && obj.status===undefined && obj.userId===undefined ){
    var request = axios.get(
      `${process.env.REACT_APP_FILE}/accountRoutes/api/v1/caseInvoices/getInvoicesWithPagination?isSent=${obj.isSent}&limit=${obj.limit}&pageNo=${obj.pageNo}`,
      {
        headers: { 'Authorization': 'bearer ' +localStorage.accountantToken}
      });
  }else{
    var request = axios.get(
      `${process.env.REACT_APP_FILE}/accountRoutes/api/v1/caseInvoices/getInvoicesWithPagination?userId=${obj.userId}&status=${obj.status}&isSent=${obj.isSent}&limit=${obj.limit}&pageNo=${obj.pageNo}`,
      {
        headers: { 'Authorization': 'bearer ' +localStorage.accountantToken}
      });
  }
 
    return dispatch => {

    dispatch(getAllInvoicesLoading());
 
    request
    .then(response => {   
   /*    console.log(response,"response")   */ 
    if (response.status == 200) {
     console.log(response,"response getAllInvoices")
    dispatch({
    type: GET_ALL_INVOICES,
    payload: response.data
    });
  
    } else {
      
    throw new Error(JSON.stringify(response.data.response.msg));
    }
    })
    .catch(error => {
        
    if (error.response) {
    if (error.response.status == "404") {
        console.log(error.response)
    dispatch(
        getAllInvoicesLoadingFailed(error.response.data.message)
    );
    } else {
    dispatch(getAllInvoicesLoadingFailed(error.response.data.message));
    }
    console.log(error.response.data);
    console.log(error.response.status);
    console.log(error.response.headers);
    } else if (error.request) {
    /*
    * The request was made but no response was received, `error.request`
    * is an instance of XMLHttpRequest in the browser and an instance
    * of http.ClientRequest in Node.js
    */
    dispatch(getAllInvoicesLoadingFailed(error.request));
    
    console.log(error.request);
    } else {
    // Something happened in setting up the request and triggered an Error
    console.log("Error", error.message);
    dispatch(getAllInvoicesLoadingFailed(error.message));
    }
    console.log(error);
    });
    };
    }


